import { Languages } from '@livv/models';
import NextHead from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { APP_URL } from '@utils/consts/livv';

type HeadMetaProps = {
    canonicalUrl?: string;
    description?: string;
    pageTitle?: string;
};

const HeadMeta: FC<HeadMetaProps> = ({ canonicalUrl, description, pageTitle }) => {
    const { t, lang } = useTranslation('common');
    const locale = `${lang}_${lang.toLocaleUpperCase()}`;

    const fullPageTitle = pageTitle ? `${pageTitle} • ${t('appTitle')}` : t('appTitle');

    const originURL = `https://${APP_URL}`;
    const imageURL = `${originURL}/assets/og.png`;

    return (
        <NextHead>
            {/* Main */}
            <title>{fullPageTitle}</title>
            {description && <meta content={description} name="description" />}
            {canonicalUrl && <link href={canonicalUrl} rel="canonical" />}
            {/* Open Graph : Facebook, LinkedIn */}
            <meta content="website" property="og:type" />
            {description && <meta content={description} property="og:description" />}
            <meta content={fullPageTitle} property="og:title" />
            <meta content={t('appTitle')} property="og:site_name" />
            <meta content={originURL} property="og:url" />
            <meta content={imageURL} property="og:image" />
            <meta content="1200" property="og:image:width" />
            <meta content="628" property="og:image:height" />
            <meta content="image/png" property="og:image:type" />
            <meta content={locale} property="og:locale" />
            {/* Twitter */}
            <meta content="summary_large_image" name="twitter:card" />
            <meta content={originURL} property="twitter:url" />
            <meta content={t('appTitle')} name="twitter:site" />
            <meta content={fullPageTitle} name="twitter:title" />
            <meta content={imageURL} property="twitter:image" />
            {description && <meta content={description} name="twitter:description" />}
            {/* SEO */}
            {lang === Languages.en && <meta content="noindex" name="robots" />}
        </NextHead>
    );
};

export default HeadMeta;
